import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const toaster = (message, type) => {
  ;<div></div>

  toast.configure()
  return type === 'success'
    ? toast.success(
        message,
        { autoClose: 2000 },
        { position: toast.POSITION.TOP_RIGHT },
      )
    : type === 'info'
    ? toast.info(
        message,
        { autoClose: 3000 },
        { position: toast.POSITION.TOP_RIGHT },
      )
    : type === 'warning'
    ? toast.warn(
        message,
        { autoClose: 3000 },
        { position: toast.POSITION.TOP_RIGHT },
      )
    : type === 'dark'
    ? toast.dark(
        message,
        { autoClose: 3000 },
        { position: toast.POSITION.TOP_RIGHT },
      )
    : type === 'error'
    ? toast.error(
        message,
        { autoClose: 3000 },
        { position: toast.POSITION.TOP_RIGHT },
      )
    : type === 'basic'
    ? toast(
        message,
        { autoClose: 3000 },
        { position: toast.POSITION.BOTTOM_CENTER },
      )
    : null
}
export default toaster
